import { copy, heading } from "@platform/ui/styles";
import { Helmet } from "react-helmet";
import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "./ErrorDisplay";
import { GoBackHome } from "./GoBackHome";

export function NotFound() {
  return (
    <>
      <Helmet title="404 - Page Not Found" />
      <div className="flex items-center justify-center">
        <ErrorDisplayRoot className="gap-2">
          <h1 className="text-ds-accent-secondary-9 mb-2 text-center text-[132px] leading-none font-bold tracking-tight md:text-[162px]">
            404
          </h1>

          <ErrorDisplayContent>
            <ErrorDisplayLockup>
              <ErrorDisplayHeadline asChild>
                <h2>Sorry, we can&apos;t find that...</h2>
              </ErrorDisplayHeadline>
              <ErrorDisplayMessage>
                The page you are looking for was moved, deleted, renamed, or may have never existed!
              </ErrorDisplayMessage>
            </ErrorDisplayLockup>
            <ErrorDisplayActions>
              <GoBackHome />
            </ErrorDisplayActions>
          </ErrorDisplayContent>
        </ErrorDisplayRoot>
      </div>
    </>
  );
}

export function NestedNotFound() {
  return (
    <>
      <Helmet title="404 - Page Not Found" />
      <div className="stack-y-6 w-full max-w-prose">
        <div className="stack-y-3">
          <h1
            className={heading({
              variant: "20",
              color: "secondary",
              className: "text-uppercase md:text-3xl",
            })}
          >
            404
          </h1>
          <h2
            className={heading({
              variant: "24",
              className: "md:text-4xl",
            })}
          >
            hmm, we can't find that page.
          </h2>
        </div>
        <p
          className={copy({
            variant: "16",
            color: "secondary",
            className: "max-w-[50ch] text-balance md:text-lg",
          })}
        >
          The page you are looking for was moved, deleted, renamed, or may have never existed!
        </p>
        <div className="flex">
          <GoBackHome />
        </div>
      </div>
    </>
  );
}
